import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { TransferenciaFichasComponent } from './transferencia-fichas.component';
import { TransferenciaFichasEditComponent } from './transferencia-fichas-edit/transferencia-fichas-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [TransferenciaFichasComponent, TransferenciaFichasEditComponent]
})
export class TransferenciaFichasModule { }
